
      var mollie2Defaults = {paymentMethod: null};
      var mollie2Cache = mollie2Defaults;

            var mollieHTMLForm = "<div id=\"gui-form-payment-method-mollie2-form\">\n  <div id=\"mollieComponentContainer\">\n    <span class=\"payment-errors gui-required\" id=\"mollie2-payment-errors\"><\/span>\n    <div class=\"gui-field\">\n      <div class=\"gui-input gui-hide\">\n        <input type=\"text\" id=\"mock-input-mollie2\"\/>\n      <\/div>\n    <\/div>\n    <div class=\"clearfix\">\n      <div class=\"gui-col2-equal\">\n        <div class=\"gui-col2-equal-col1\">\n          <div class=\"gui-field\">\n            <label for=\"mollie2-card-number\">Kaartnummer <em>*<\/em><\/label>\n            <div class=\"gui-input\">\n              <div id=\"mollie2-card-number\"><\/div>\n            <\/div>\n          <\/div>\n        <\/div>\n        <div class=\"gui-col2-equal-col2\">\n          <div class=\"gui-field\">\n            <label for=\"mollie2-card-holder\">Naam op de kaart <em>*<\/em><\/label>\n            <div class=\"gui-input\">\n              <div id=\"mollie2-card-holder\"><\/div>\n            <\/div>\n          <\/div>\n        <\/div>\n      <\/div>\n    <\/div>\n    <div class=\"clearfix\">\n      <div class=\"gui-col2-equal\">\n        <div class=\"gui-col2-equal-col1\">\n          <div class=\"gui-field\">\n            <label for=\"mollie2-expiry-date\">Vervaldatum <em>*<\/em><\/label>\n            <div class=\"gui-input\">\n              <div id=\"mollie2-expiry-date\"><\/div>\n            <\/div>\n          <\/div>\n        <\/div>\n        <div class=\"gui-col2-equal-col2\">\n          <div class=\"gui-field\">\n            <label for=\"mollie2-verification-code\">CVV <em>*<\/em><\/label>\n            <div class=\"gui-input\">\n              <div id=\"mollie2-verification-code\"><\/div>\n            <\/div>\n          <\/div>\n        <\/div>\n      <\/div>\n    <\/div>\n  <\/div>\n<\/div>";

      $async.dependencies('mollie', function() {
          setTimeout(function () {
              var methodSelector = $('input[name="payment_method"][data-provider="seoshoppayments"]:checked');

              evaluateOptions($(methodSelector).data('method'));
          }, 0);

          if (typeof window.mollieEventlistenersRegistered === 'undefined') {
              $(document).on('change', 'input[name="shipment_method"], input[name="payment_method"]', function (e) {
                  evaluateOptions($(this).data('method'));
              });

              window.mollieEventlistenersRegistered = true;

              init();

              var form = $('#gui-form');

              form.submit(function (e) {
                  var methodSelector = $('input[name="payment_method"][data-provider="seoshoppayments"]:checked');

                  if (methodSelector.length && $('#gui-form-payment-method-mollie2-' + methodSelector.data('method')).is(':visible')) {
                      e.preventDefault();

                      window.mollie.createToken().then(function (result) {
                          if (result && result.token) {
                              $('.js-mollie2-token').val(result.token);
                              form.off('submit').submit();
                          } else if (result && result.error && result.error.message) {
                              $('#mollie2-payment-errors').text(result.error.message);
                          } else {
                              $('#mollie2-payment-errors').text('Probeer het opnieuw of kies een andere betaalmethode.');
                          }
                      });
                  }
              });
          }

          function init() {
              window.mollie = Mollie('pfl_KtW9Ez8FbD', {
                  locale: 'nl_NL',
                  testmode: false});

              var inputStyle = retrieveInputStyles();
              cardHolder = window.mollie.createComponent('cardHolder', inputStyle);
              cardNumber = window.mollie.createComponent('cardNumber', inputStyle);
              expiryDate = window.mollie.createComponent('expiryDate', inputStyle);
              verificationCode = window.mollie.createComponent('verificationCode', inputStyle);
          }

          function evaluateOptions(paymentMethod) {
              if (mollie2Cache.paymentMethod === null) {
                  mollie2Cache.paymentMethod = paymentMethod;
                  register(paymentMethod);
              } else if (mollie2Cache.paymentMethod != paymentMethod) {
                  mollie2Cache.paymentMethod = paymentMethod;
                  unregister();
                  register(paymentMethod);
              }
          }

          function register(paymentMethod) {
              var available = ["visa","mastercard","cartesbancaires","americanexpress","maestro"];

              if (available.indexOf(paymentMethod) === -1) return;

              $(mollieHTMLForm).appendTo($('#gui-form-payment-method-mollie2-' + paymentMethod));

              cardHolder.mount('#mollie2-card-holder');
              cardNumber.mount('#mollie2-card-number');
              expiryDate.mount('#mollie2-expiry-date');
              verificationCode.mount('#mollie2-verification-code');

              [cardHolder, cardNumber, expiryDate, verificationCode].forEach(function (field) {
                  field.addEventListener('change', function(event) {
                      if (event.error && event.touched) {
                          $('#mollie2-payment-errors').text(event.error);
                      } else {
                          $('#mollie2-payment-errors').text('');
                      }
                  });
              });
          }

          function unregister() {
              mollie2Cache = mollie2Defaults;
              $('#gui-form-payment-method-mollie2-form').remove();
          }

          function retrieveInputStyles() {
              var mockInput = $('#gui-form-login-email');
              return {
                  styles: {
                      base: {
                          fontSize: mockInput.css('font-size'),
                          color: mockInput.css('color'),
                          fontWeight: '' + mockInput.css('font-weight'), // Safari only accepts string values
                          lineHeight: mockInput.css('line-height'),
                          backgroundColor: mockInput.css('background-color'),
                          textAlign: mockInput.css('text-align'),
                          letterSpacing: mockInput.css('letter-spacing'),
                      }
                  }
              };
          }
      });
  